var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmbed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.50003 7.49994C1.23481 7.49994 0.980445 7.39459 0.792903 7.20705C0.60536 7.01952 0.5 6.76517 0.5 6.49995V1.49999C0.5 1.23478 0.60536 0.980426 0.792903 0.792891C0.980445 0.605356 1.23481 0.5 1.50003 0.5H6.5002C6.76542 0.5 7.01978 0.605356 7.20732 0.792891C7.39487 0.980426 7.50023 1.23478 7.50023 1.49999",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5002 3.5H4.50003C3.94773 3.5 3.5 3.94771 3.5 4.49999V9.49995C3.5 10.0522 3.94773 10.4999 4.50003 10.4999H9.5002C10.0525 10.4999 10.5002 10.0522 10.5002 9.49995V4.49999C10.5002 3.94771 10.0525 3.5 9.5002 3.5Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.00002 6L5.5 6.99999L6.00002 7.99998M8.00008 6L8.5001 6.99999L8.00008 7.99998",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmbed);
export default __webpack_public_path__ + "static/media/embed.53c6cf097474faaa1cb861537ac58ac8.svg";
export { ForwardRef as ReactComponent };